import React, { useRef, useState } from "react";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { HeadingTextBlock } from "../../types/strapi";

interface TabsProps {
  items?: HeadingTextBlock[];
}

const Tabs: React.FC<TabsProps> = ({ items = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const tabBarRef = useRef<HTMLDivElement>(null);

  if (!items.length) return null;

  const selectTab = (index: number) => {
    setActiveIndex(index);
    tabBarRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <div ref={tabBarRef} className="container text-center mt--100">
        {items.map((item, index) => (
          <a
            key={`tab${index}`}
            className={`btn-default ${activeIndex !== index ? "btn-border" : ""} size-md color-secondary ml--20 mt--20`}
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.preventDefault();
              selectTab(index);
            }}
            onKeyDown={(e) => e.key === "Enter" && selectTab(index)}
          >
            <span>{item.heading}</span>
          </a>
        ))}
      </div>
      <div className="container mt-xl-5 mb-xl-5">
        <div className="row">
          <div className="col-lg-12">
            <div className="inner-wrapper">
              <div className="inner">
                <BlocksRenderer content={items[activeIndex]?.textBlock || []} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tabs;
